'use strict';

import React from 'react'

import PageWrapper from '@Layout/PageWrapper'
import Layout from '@Layout/BackOffice'

import getFormStatus from '@/Form/Functions/getFormStatus'

export default PageWrapper(function NewsLetterPage (props)
{
	return (
		<Layout history={ props.history } page_title="Export pour la Newsletter">

			<div className="page-content">

				{ getFormStatus({ statement: 'Les utiliateurs ayant décoché la newsletter sur leur profil auront la colonne de consentement à non, ceux l\'ayant coché à oui, ceux qui n\'ont pas mis à jour leur compte à non communiqué et lorsque le consentement n\'est pas requis (Email CSE) N/A est spécifié (non applicable).' }) }

				<a href="/export/newsletter" target="_blank" className="c-btn">
					E-mails des membres &amp; admins de CE
				</a>

				<a href="/export/newsletter?option=elus"
					target="_blank" className="c-btn u-margin-left-20">
					E-mails des admins de CE &amp; CSE
				</a>

				<a href="/export/newsletter?option=partenaires"
					target="_blank" className="c-btn u-margin-left-20">
					E-mails des partenaires
				</a>

			</div> { /* /page-content */ }

		</Layout>
	);
});